module.exports = __webpack_public_path__ + "static/media/tatasky.92bd7fb1.png";